import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "./context/ThemeContext";

// Clean up developer console from harmless third-party React 19 / YouTube warnings in development
if (process.env.NODE_ENV === "development") {
  const ignorePatterns = [
    "Accessing element.ref was removed in React 19",
    "Failed to execute 'postMessage' on 'DOMWindow'",
    "Download the React DevTools",
    "react-devtools"
  ];

  const shouldIgnore = (args) => {
    return args.some(arg => {
      if (!arg) return false;
      try {
        const str = typeof arg === "string" ? arg : (arg.message || String(arg) || "");
        return ignorePatterns.some(pat => str.toLowerCase().includes(pat.toLowerCase()));
      } catch (e) {
        return false;
      }
    });
  };

  const overrideConsole = (method) => {
    const original = console[method];
    console[method] = (...args) => {
      if (shouldIgnore(args)) {
        return;
      }
      original(...args);
    };
  };

  ["log", "warn", "error", "info"].forEach(overrideConsole);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
